module.exports = __webpack_public_path__ + "img/temperature-snow.a6737f57.svg";